/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TagIcon24Regular = forwardRef('TagIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6 13.252a1.251 1.251 0 1 0 0-2.503 1.251 1.251 0 0 0 0 2.502Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.458 4.25A3.75 3.75 0 0 0 4.51 5.683l-3.142 4a3.75 3.75 0 0 0 0 4.634l3.142 4a3.75 3.75 0 0 0 2.95 1.433H18A3.75 3.75 0 0 0 21.75 16V8A3.75 3.75 0 0 0 18 4.25H7.458Zm-1.77 2.36a2.25 2.25 0 0 1 1.77-.86H18A2.25 2.25 0 0 1 20.25 8v8A2.25 2.25 0 0 1 18 18.25H7.458a2.25 2.25 0 0 1-1.77-.86l-3.142-4a2.25 2.25 0 0 1 0-2.78l3.143-4Z" })));
});
